export const phoneNumberRegExp = /^[0-9]{6,20}$/;
